module.exports = __webpack_public_path__ + "img/Fotoespacio.92ceac84.png";